module.exports = __webpack_public_path__ + "static/img/logo-light.61e7b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-light.png
// module id = 25tw
// module chunks = 1